var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.597 200.422H200.054C204.785 200.422 209.322 198.542 212.667 195.197C216.012 191.852 217.891 187.315 217.891 182.585V89.0083C217.891 84.2777 216.012 79.7407 212.667 76.3957C209.322 73.0507 204.785 71.1714 200.054 71.1714H115.597C110.866 71.1714 106.33 73.0507 102.984 76.3957C99.6395 79.7407 97.7603 84.2777 97.7603 89.0083V131.018",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.992 6.12625H134.956C133.118 6.12625 131.297 6.48846 129.598 7.19219C127.899 7.89592 126.355 8.92739 125.055 10.2277C123.754 11.528 122.723 13.0718 122.019 14.7707C121.315 16.4697 120.953 18.2906 120.953 20.1295V71.189H195.083V20.1295C195.083 18.2832 194.718 16.4551 194.009 14.7504C193.3 13.0457 192.26 11.4981 190.951 10.1966C189.641 8.89517 188.087 7.86552 186.378 7.16696C184.669 6.4684 182.839 6.11471 180.992 6.12625Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.214 27.4287H193.876",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.262 217.891C121.941 217.891 119.715 216.969 118.073 215.327C116.432 213.686 115.51 211.46 115.51 209.139V200.387H132.891V209.139C132.892 211.439 131.986 213.647 130.371 215.284C128.756 216.922 126.562 217.859 124.262 217.891Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.892 128.795C176.135 126.042 172.399 124.497 168.503 124.497C164.607 124.497 160.871 126.042 158.114 128.795C155.358 126.042 151.621 124.497 147.726 124.497C143.83 124.497 140.094 126.042 137.337 128.795C134.585 131.552 133.039 135.288 133.039 139.184C133.039 143.079 134.585 146.816 137.337 149.572L155.804 168.039C156.109 168.345 156.472 168.588 156.872 168.753C157.271 168.919 157.699 169.004 158.132 169.004C158.564 169.004 158.992 168.919 159.392 168.753C159.791 168.588 160.154 168.345 160.46 168.039L178.892 149.625C181.644 146.868 183.19 143.132 183.19 139.236C183.19 135.341 181.644 131.604 178.892 128.847",
    fill: "#B2B2B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3217 33.5724C80.9759 32.2265 79.3783 31.1589 77.6198 30.4305C75.8614 29.7021 73.9765 29.3271 72.0731 29.3271C70.1698 29.3271 68.2852 29.7021 66.5267 30.4305C64.7683 31.1589 63.1704 32.2265 61.8246 33.5724C60.4787 32.2265 58.8809 31.1589 57.1224 30.4305C55.364 29.7021 53.4791 29.3271 51.5757 29.3271C49.6724 29.3271 47.7878 29.7021 46.0293 30.4305C44.2709 31.1589 42.673 32.2265 41.3272 33.5724C39.9813 34.9183 38.9135 36.5161 38.1851 38.2745C37.4567 40.033 37.082 41.9177 37.082 43.8211C37.082 45.7245 37.4567 47.6092 38.1851 49.3677C38.9135 51.1261 39.9813 52.7239 41.3272 54.0697L59.5316 72.274C59.8324 72.5757 60.1897 72.815 60.5831 72.9783C60.9766 73.1417 61.3986 73.2257 61.8246 73.2257C62.2506 73.2257 62.6723 73.1417 63.0658 72.9783C63.4592 72.815 63.8167 72.5757 64.1176 72.274L82.3217 54.0697C83.6676 52.7239 84.7354 51.1261 85.4638 49.3677C86.1922 47.6092 86.5671 45.7245 86.5671 43.8211C86.5671 41.9177 86.1922 40.033 85.4638 38.2745C84.7354 36.5161 83.6676 34.9183 82.3217 33.5724Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.338 217.891C189.016 217.891 186.79 216.969 185.149 215.327C183.508 213.686 182.585 211.46 182.585 209.139V200.387H199.967V209.139C199.967 211.439 199.062 213.647 197.447 215.284C195.832 216.922 193.637 217.859 191.338 217.891Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5571 217.873H23.333V132.226H40.5571V217.873Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1489 217.873H98.3731V132.226H81.1489V217.873Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.299 132.226H21.3727C17.3199 132.226 13.433 133.836 10.5672 136.701C7.70147 139.567 6.09131 143.454 6.09131 147.507V202.592C6.09131 206.645 7.70147 210.532 10.5672 213.397C13.433 216.263 17.3199 217.873 21.3727 217.873H100.281C104.334 217.873 108.221 216.263 111.087 213.397C113.952 210.532 115.562 206.645 115.562 202.592V147.507C115.562 143.457 113.954 139.573 111.092 136.707C108.23 133.842 104.348 132.23 100.299 132.226Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6224 112.009H48.0839C46.0877 112.009 44.1732 112.802 42.7617 114.213C41.3502 115.625 40.5571 117.539 40.5571 119.536V132.226H81.1491V119.536C81.1491 117.539 80.3561 115.625 78.9446 114.213C77.533 112.802 75.6186 112.009 73.6224 112.009Z",
    stroke: "#B2B2B2",
    strokeWidth: 8.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.893 105.112H120.918V95.0996H193.893V105.112Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.3a5b108d96b7ac488c98719b44e2c12e.svg";
export { ForwardRef as ReactComponent };